export default "__VITE_ASSET__BDNt$HTk__"